import classNames from 'classnames';
import React, { useLayoutEffect, useRef, useState } from 'react';
import Button from '../components/Button';
import SVGIcon from '../components/SVGIcon';
import styles from './SidebarNavItem.module.scss';

interface SidebarNavItemProps {
  children: React.ReactNode;
  icon?: React.ReactNode;
  to?: string;
  onClick?: React.MouseEventHandler;
  onlyActiveOnIndex?: boolean;
  subItem?: boolean;
  type?: 'post' | 'template' | 'topic' | 'general' | 'rootTemplates';
  rightContent?: React.ReactNode;
  archived?: boolean;
}

const SidebarNavItem = ({
  children,
  icon,
  to,
  onClick,
  onlyActiveOnIndex,
  subItem,
  type = 'general',
  rightContent,
  archived,
}: SidebarNavItemProps) => {
  const [rightContentWidth, setRightContentWidth] = useState(0);
  const rightContentRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const rightContentElement = rightContentRef.current;
    if (rightContentElement) {
      const rect = rightContentElement.getBoundingClientRect();
      setRightContentWidth(rect.width);
    }
  }, [rightContent]);

  return (
    <div className={styles.container}>
      <div ref={rightContentRef} className={styles.rightContent}>
        {rightContent}
      </div>
      <Button
        to={to}
        onClick={onClick}
        variant="link"
        block
        className={classNames(styles.navItem, {
          [styles.subItem]: subItem,
          [styles.topic]: type === 'topic',
          [styles.post]: type === 'post',
          [styles.template]: type === 'template',
          [styles.rootTemplates]: type === 'rootTemplates',
          [styles.archived]: archived,
        })}
        activeClassName={styles.active}
        onlyActiveOnIndex={onlyActiveOnIndex}
      >
        {!!icon && (
          <div className={styles.navItemIcon}>
            {typeof icon === 'string' ? (
              <SVGIcon size={subItem ? 12 : 'regular'}>{icon}</SVGIcon>
            ) : (
              icon
            )}
          </div>
        )}
        <div
          className={styles.content}
          style={{ paddingRight: rightContentWidth }}
        >
          {children}
        </div>
      </Button>
    </div>
  );
};

export default SidebarNavItem;
